mutation Inertia_UpdateImportedParticipants(
  $orderId: ID!
  $selectedExternalIds: [String!]!
  $rawSnapshot: JSON
  $nameUpdates: [NameUpdateInput!]
) {
  updateImportedParticipants(
    input: {
      orderId: $orderId
      selectedExternalIds: $selectedExternalIds
      rawSnapshot: $rawSnapshot
      nameUpdates: $nameUpdates
    }
  ) {
    order {
      id
    }
    errors
  }
}
